import { clsx } from "clsx";
import type { CSSProperties, FC } from "react";

import style from "./Badge.module.css";
export interface BadgeProps {
  /** @default "" */
  label: string | number;
  className?: string;
  style?: CSSProperties;
  inline?: boolean;
  intent?: "primary" | "secondary" | "danger" | "light";
  large?: boolean;
}

/**
 * To be used with other component to show something notification count like information.
 * It is already implemented in the `TriggerButton`.
 */
export const Badge: FC<BadgeProps> = (props) => {
  return (
    <div
      className={clsx(style.badge, props.className, {
        [style.absolute]: props.inline !== true,
        [style.large]: props.large,
        [style.danger]: props.intent === "danger",
        [style.light]: props.intent === "light",
        [style.secondary]: props.intent === "secondary",
      })}
      style={props.style}
      data-testid={"notification-bullet"}
    >
      {props.label}
    </div>
  );
};
